import React, { useState, useEffect } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TablePagination,
  CircularProgress,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import api from '../../config/api'
import { formatDate } from '../../shared/dateFormater'
import { useNavigate } from 'react-router-dom'
const OrderHistory = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    page: 0,
    perPage: 15,
    totalPages: 1,
    totalItems: 0,
  })
  const [orderBy, setOrderBy] = useState('date_create')
  const [order, setOrder] = useState('desc')

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await api.get('/API_FRONT/cart/items/get-list', {
        params: {
          page: pagination.page + 1,
          sort: `${order === 'desc' ? '-' : ''}${orderBy}`,
        },
      })

      setData(response.data.data)
      setPagination((prev) => ({
        ...prev,
        totalPages: response.data.pagination.total_pages,
        totalItems: response.data.pagination.total_items,
      }))
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [pagination.page, orderBy, order])

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
    setPagination((prev) => ({ ...prev, page: 0 }))
  }

  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }))
  }

  const columns = [
    { id: 'id', label: 'ID', minWidth: 50 },
    { id: 'date_create', label: 'Дата создания', minWidth: 120 },
    { id: 'date_of_arraving', label: 'Дата прибытия', minWidth: 120 },
    { id: 'total', label: 'Сумма', minWidth: 80, align: 'right' },
    { id: 'status', label: 'Статус', minWidth: 100 },
  ]

  const mobileColumns = ['id', 'date_create', 'total', 'status']

  const visibleColumns = isMobile
    ? columns.filter((col) => mobileColumns.includes(col.id))
    : columns

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : data.length === 0 ? (
          <Typography sx={{ p: 2 }}>Нет данных для отображения</Typography>
        ) : (
          <Table
            stickyHeader
            aria-label="sticky table"
            size={isMobile ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                {visibleColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={() => handleSort(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.id}
                  onClick={() => navigate(`/carts/${row.id}`)} // Добавляем обработчик клика
                  style={{ cursor: 'pointer' }} // Указываем стиль курсора
                >
                  {visibleColumns.map((column) => {
                    const value = row[column.id]
                    return (
                      <TableCell key={column.id} align={column.align || 'left'}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[15]}
        component="div"
        count={pagination.totalItems}
        rowsPerPage={pagination.perPage}
        page={pagination.page}
        onPageChange={handleChangePage}
        labelRowsPerPage="Элементов на странице:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} из ${count}`
        }
      />
    </Paper>
  )
}

export default OrderHistory
